import { Component, Input } from '@angular/core';
import { DoubleBooking, DoubleBookings } from '@models/double-booking.model';
import { SNModalService } from '@web-services/modal/snModal.service';
import { DoubleBookingDetailsModalComponent } from '@web-components/common/double-booking/double-booking-details/double-booking-details-modal';
import { DoubleBookingService } from '@services/double-booking/double-booking.service';

@Component({
	selector: 'double-booking',
	template: require('./double-booking.html'),
	styles: [require('./double-booking.scss')]
})
export class DoubleBookingComponent {
	@Input() doubleBooking: DoubleBookings;

	constructor(
		private modalService: SNModalService,
		private doubleBookingService: DoubleBookingService
	) {}

	openDoubleBookingDetails(ev: MouseEvent, doubleBooking: DoubleBooking): void {
		ev.preventDefault();
		ev.stopPropagation();

		const { SHOW_OVERLAPPING_EVENTS, OPEN_TAB } = doubleBooking.actions;

		if (SHOW_OVERLAPPING_EVENTS) {
			const modal = this.modalService.openModal(
				DoubleBookingDetailsModalComponent
			);

			const dataToShow = this.doubleBookingService.parseEventsToShow(
				doubleBooking.events
			);

			modal.componentInstance.doubleBookingInfo = this.doubleBookingService.sortDoubleBookingEvents(
				dataToShow
			);
		}

		if (OPEN_TAB) {
			window.open(OPEN_TAB.url, '_blank');
		}
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=os2z8rc99lf!./web/modern/components/common/double-booking/double-booking.ts